import { informes, procedimientos } from "./models";


var documentos = [];

var articulos = {
    id: 'articulos',
    description: 'Artículos',
    icon: 'fa fa-shopping-cart',
    text: 'ARTÍCULOS',
    ruta: 'articulos'
};
var articulos_proveedor = {
    id: 'articulos_proveedor',
    description: 'Artículos',
    icon: 'fa fa-shopping-cart',
    text: 'ARTÍCULOS PROVEEDOR',
    ruta: 'articulos_proveedor'
};
var packs = {
    id: 'packs',
    description: 'Packs',
    icon: 'fa fa-tasks',
    text: 'PACKS',
    ruta: 'packs'
};
var proveedores = {
    id: 'proveedores',
    description: 'Proveedores',
    icon: 'fa fa-user-circle',
    text: 'PROVEEDORES',
    ruta: 'proveedores'
};
var clientes = {
    id: 'clientes',
    description: 'Clientes',
    icon: 'fa fa-user',
    text: 'CLIENTES',
    ruta: 'clientes'
};
var ofertas = {
    id: 'ofertas',
    description: 'Ofertas',
    icon: 'fa fa-shopping-basket',
    text: 'OFERTAS',
    ruta: 'ofertas'
};
var ofertas_packs = {
    id: 'ofertas_packs',
    description: 'Ofertas Packs',
    icon: 'fa fa-shopping-basket',
    text: 'OFERTAS PACKS',
    ruta: 'ofertas_packs'
};

export var formularios = [
    [
        {
            procedimiento: '',
            referencia: '',
            referencia_num: '',
            revision: '',
            titulo: '',
        }
    ]
];


export function getProcedimiento(procedure: string): any {
    rellenarProcedimientos()
    let respuesta: any = [];

    respuesta = documentos.find(doc => doc.id.localeCompare(procedure) == 0);

    return respuesta;

}

export function getDocumento(documento: string) {
    rellenarProcedimientos();

    let respuesta: any;
    for (let index = 0; index < documentos.length; index++) {
        const element = documentos[index]['informes'];


        for (let index2 = 0; index2 < element.length; index2++) {
            const element2 = element[index2];
            if (element2.id.localeCompare(documento) == 0) {
                index2 = element.length;
                index = documentos.length;
                respuesta = element2;
            }

        }

    }
    return respuesta;

}


function rellenarProcedimientos() {
    documentos = [];

    documentos.push(articulos);
    documentos.push(packs);
    documentos.push(proveedores);
    documentos.push(clientes);
    documentos.push(ofertas);
    documentos.push(ofertas_packs);


}


/* export function rellenarMenUsuario() {
    documentos = [];
    documentos.push(articulos_proveedor);
    console.log('documentos', documentos);
    
    let respuesta: any[] = [];

    for (let index = 0; index < documentos.length; index++) {
      
        try {
            const element: any = documentos[index];
           
            let menu = { id: element.id, icon: 'fa band-aid', text: element.text, description: element.text, isSelected: false }
            let proce = {
                id: documentos[index]['id'],
                icon: documentos[index]['icon'],
                text: documentos[index]['text'],
                description: documentos[index]['description'],
                isSelected: documentos[index]['isSelected'],
                expandable: false
            }
            respuesta.push(proce);
            

        } catch (error) {
            console.log('error', error);
            
        }

    }
    respuesta.unshift({ id: '', icon: 'fa fa-home', text: 'INICIO', description: 'INICIO', isSelected: false })
    
    return respuesta;

} */

export function rellenarMenUsuario() {
    documentos = [];
    documentos.push(articulos_proveedor);
    let respuesta: any[] = [];
    let respuesta_item_menu: any[] = [];
    /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
    for (let index = 0; index < documentos.length; index++) {
        try {
            respuesta_item_menu = [];
            if ( documentos[index]['informes'] == null || documentos[index]['informes'].length == 0) {
                respuesta.push(documentos[index]);
            } else {
                const element: informes[] = documentos[index]['informes'];
                for (let index2 = 0; index2 < element.length; index2++) {
                    const element2 = element[index2];
                    let item_menu = { id: element2.id, fatherId: documentos[index].id, text: element2.full_title, description: element2.full_title, isSelected: false }
                    respuesta_item_menu.push(item_menu);
                }
    
                //respuesta_item_menu.push({ id: '', fatherId: '', text: '', description: '', isSelected: false });
                let proce = {
                    id: documentos[index]['id'],
                    icon: documentos[index]['icon'],
                    text: documentos[index]['text'],
                    description: documentos[index]['description'],
                    isSelected: documentos[index]['isSelected'],
                    expandable: respuesta_item_menu
                }
                
                respuesta.push(proce);
            }
           
        } catch (error) {
            
        }

    }
    respuesta.unshift({ id: '', icon: 'fa fa-home', text: 'INICIO', description: 'INICIO', isSelected: false })
  
    return respuesta;

}
export function rellenarMenuAdmin() {
    rellenarProcedimientos();
    let respuesta: any[] = [];
    let respuesta_item_menu: any[] = [];
    /* respuesta.push( {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false }); */
    for (let index = 0; index < documentos.length; index++) {
        try {
            respuesta_item_menu = [];
            if ( documentos[index]['informes'] == null || documentos[index]['informes'].length == 0) {
                respuesta.push(documentos[index]);
            } else {
                const element: informes[] = documentos[index]['informes'];
                for (let index2 = 0; index2 < element.length; index2++) {
                    const element2 = element[index2];
                    let item_menu = { id: element2.id, fatherId: documentos[index].id, text: element2.full_title, description: element2.full_title, isSelected: false }
                    respuesta_item_menu.push(item_menu);
                }
    
                //respuesta_item_menu.push({ id: '', fatherId: '', text: '', description: '', isSelected: false });
                let proce = {
                    id: documentos[index]['id'],
                    icon: documentos[index]['icon'],
                    text: documentos[index]['text'],
                    description: documentos[index]['description'],
                    isSelected: documentos[index]['isSelected'],
                    expandable: respuesta_item_menu
                }
                
                respuesta.push(proce);
            }
           
        } catch (error) {
            
        }

    }
    respuesta.unshift({ id: '', icon: 'fa fa-home', text: 'INICIO', description: 'INICIO', isSelected: false })
  
    return respuesta;

}